import { render, staticRenderFns } from "./ResultPoll.vue?vue&type=template&id=208d0a98&scoped=true&"
import script from "./ResultPoll.vue?vue&type=script&lang=js&"
export * from "./ResultPoll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208d0a98",
  null
  
)

export default component.exports